/**
 * Elevation / shadow tokens — replaces bespoke shadow-[…] literals.
 */

// Single source for the neutral card shadow — referenced by both `card` and the
// elevation tiers so the literal lives in exactly one place (WI-3 "3+ → token").
const CARD_SHADOW = 'shadow-[0_20px_60px_rgba(0,0,0,0.35)]';

export const shadows = {
  none: '',
  /** Subtle brand-tinted lift (Start-a-Lock card mobile) */
  brandSm: 'shadow-[0_8px_24px_rgba(16,185,129,0.06)]',
  /** Brand-tinted lift (Start-a-Lock card desktop, primary button) */
  brandMd: 'shadow-[0_12px_32px_rgba(16,185,129,0.25)]',
  brandLg: 'shadow-[0_12px_40px_rgba(16,185,129,0.08)]',
  /** Start-a-Lock card — mobile + desktop brand shadow */
  brandCard: 'shadow-[0_8px_24px_rgba(16,185,129,0.06)] md:shadow-[0_12px_40px_rgba(16,185,129,0.08)]',
  /** Neutral card elevation */
  card: CARD_SHADOW,
  /** Modal panel */
  modal: 'shadow-[0_20px_60px_rgba(0,0,0,0.5)]',
  /** Strong brand modal accent */
  modalBrand: 'shadow-[0_20px_60px_rgba(16,185,129,0.2)]',
  /** Premium glass card — subtle lift + inner glow */
  premiumGlass: 'shadow-[0_8px_32px_rgba(0,0,0,0.45),inset_0_1px_0_rgba(255,255,255,0.06)]',
  /** Wallet balance card elevation */
  wallet: 'shadow-[0_12px_40px_rgba(168,85,247,0.12)]',
  /** Glass / decorative */
  glass: 'shadow-2xl',
  /**
   * Semantic elevation tiers (WI-3 §1) — callers name the *tier*, not the raw
   * shadow. Alias only; values already exist above. The Featured tier's glow is
   * sport-specific (`SPORT_NEON.glow`) and applied alongside this, not baked in.
   *
   * | Tier        | Meaning                          | Used by                       |
   * |-------------|----------------------------------|-------------------------------|
   * | surface     | background containers (flat)     | sections, banner stack        |
   * | interactive | things you act on                | LobbyMatchupCard, live card   |
   * | featured    | the single focal block           | FeaturedMatchupHero (+ glow)  |
   */
  elevation: {
    surface: '',
    interactive: CARD_SHADOW,
    featured: CARD_SHADOW,
  },
};
